import { useState } from "react";
import { useAppContext } from "../../../context/AuthContext";
import { ArticleController, ArticleControllerType } from "../../../controller/article/ArticleController";
import { handleErrorMessage, useEffectOnce } from "../../../utils/Utils";
interface ToDoListServiceType {
  completedList: any;
  pendingList: any;
  decideList: any;
  postAcceptDeclineArticle: any;
}

export default function ReviewerToDoListService(): ToDoListServiceType {
  const { showMessage, setBlockUI } = useAppContext();
  const { axiosGetReviewerToDoList, axiosPostAcceptDeclineArticle }: ArticleControllerType = ArticleController();
  const [completedList, setCompletedList] = useState([]);
  const [decideList, setDecideList] = useState([]);
  const [pendingList, setPendingList] = useState([]);

  useEffectOnce(() => {
    getReviewerToDoList();
  });

  const getReviewerToDoList = () => {
    setBlockUI(true);
    axiosGetReviewerToDoList()
      .then((result: any) => {
        setPendingList(result.data.pending);
        setDecideList(result.data.decide);
        setCompletedList(result.data.completed);
      })
      .catch((error: any) => handleErrorMessage(showMessage, error))
      .finally(() => setBlockUI(false));
  };

  const postAcceptDeclineArticle = (articleId: any, reviewId: any, response: any) => {
    axiosPostAcceptDeclineArticle(articleId, reviewId, response)
      .then((response: any) => getReviewerToDoList())
      .catch((error: any) => handleErrorMessage(showMessage, error));
  };

  return { completedList, pendingList, decideList, postAcceptDeclineArticle };
}
export type { ToDoListServiceType };
